import type { TFunction } from 'i18next';
import type { StudioCost } from './types';

/** "35 cr", "from 35 cr", "PDF $179 MXN · $9.99 USD". Only numbers the server sent. */
export function costLabel(cost: StudioCost | undefined, t: TFunction): string | null {
  if (!cost) return null;
  if (typeof cost.credits === 'number') {
    return cost.from ? t('reel.cost.fromCredits', { credits: cost.credits }) : t('reel.cost.credits', { credits: cost.credits });
  }
  if (cost.money) return t('reel.cost.bookPdf', { mxn: cost.money.mxn.toFixed(0), usd: cost.money.usd.toFixed(2) });
  return null;
}

export function freeLabel(cost: StudioCost | undefined, t: TFunction): string | null {
  return cost?.free_first ? t(`reel.freeFirst.${cost.free_first}`) : null;
}
